import { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import DownloadPage from "@/pages/DownloadPage";
import NotFound from "@/pages/not-found";
import { LazyMotion, domAnimation } from "framer-motion";
import ThemeProvider from "@/components/ThemeProvider";
import HomePage from "./pages/HomePage";
import RingsPage from "./pages/RingsPage";
import SmartBandsPage from "./pages/SmartBandsPage";
import HoursPage from "./pages/WatchesPage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/trackerPage";
import BioLinkPage from "./pages/BioLinkPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { Suspense, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingScreen from "./components/LoadingScreen";
import PWAInstallButton, { PWAStatus } from "./components/PWAInstallButton";

const queryClient = new QueryClient();

function AppContent() {
  const { i18n } = useTranslation();

  // Update document direction based on language
  useEffect(() => {
    const dir = i18n.dir(i18n.language);
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
    document.body.dir = dir; // Ensure body also gets the attribute if needed
  }, [i18n.language]);

  const [isLoading, setIsLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    // بارگذاری منابع و آماده‌سازی صفحه با گارد زمان
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  // اگر لودینگ در حال انجام است
  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LazyMotion features={domAnimation}>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="download" element={<DownloadPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="tracker" element={<ServicesPage />} />
              <Route path="rings" element={<RingsPage />} />
              <Route path="smart-bands" element={<SmartBandsPage />} />
              <Route path="watches" element={<HoursPage />} />
              <Route path="biolink" element={<BioLinkPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
          </LazyMotion>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <AppContent />
    </Suspense>
  );
}
